import React, { useMemo, useState } from 'react'
import PopUp from '../../../ui/PopUp/PopUp'
import Icon from '../../../ui/Icon/Icon'
import CatalogTaxonomyNodePicker from '../../Products/productSchema/CatalogTaxonomyNodePicker'
import {
  buildCatalogTaxonomyNodePathLabel,
  buildCatalogTaxonomyNodePathSegments,
  buildCatalogTaxonomyNodesById,
} from '../../Products/productSchema/formatProductTaxonomySummary'
import { createPackagingCategorySelection } from '../../../api/marketing/gifts/packagingCategorySelection'
import '../UtmBuilder/RelatedCategoryPicker.sass'
import packagingStyles from './PackagingCategoryPicker.module.scss'

function GiftFundCategoryPicker({
  value = null,
  onChange,
  nodes = [],
  label = 'Категорія',
  popupTitle = 'Оберіть категорію',
}) {
  const [isOpen, setIsOpen] = useState(false)
  const isMulti = Array.isArray(value)
  const selectedList = isMulti ? value.filter(Boolean) : value ? [value] : []
  const selectedIds = selectedList.map((item) => item.catalogTaxonomyNodeId).filter(Boolean)
  const pathLabel = !isMulti ? value?.pathLabel || '' : ''
  const selectedNodeId = !isMulti ? value?.catalogTaxonomyNodeId || null : selectedIds[selectedIds.length - 1] || null
  const hasValue = isMulti ? selectedList.length > 0 : Boolean(pathLabel || selectedNodeId)

  const visibleNodes = useMemo(
    () => (nodes || []).filter((node) => node && node.isArchived !== true),
    [nodes]
  )
  const nodesById = useMemo(() => buildCatalogTaxonomyNodesById(visibleNodes), [visibleNodes])

  const handlePick = (node) => {
    const nextPathLabel = buildCatalogTaxonomyNodePathLabel(node.id, nodesById)
    const pathIds = buildCatalogTaxonomyNodePathSegments(node.id, nodesById).map((segment) => segment.id)
    const selection = createPackagingCategorySelection({
      node,
      pathLabel: nextPathLabel,
      pathIds,
    })
    if (isMulti) {
      if (selectedIds.includes(node.id)) {
        setIsOpen(false)
        return
      }
      onChange([...selectedList, selection])
    } else {
      onChange(selection)
    }
    setIsOpen(false)
  }

  const handleRemove = (nodeId) => {
    if (isMulti) {
      onChange(selectedList.filter((item) => item.catalogTaxonomyNodeId !== nodeId))
      return
    }
    onChange(null)
  }

  return (
    <div className="UtmBuilder-RelatedCategoryField">
      <div
        className={[
          'Field',
          isMulti ? 'UtmBuilder-RelatedBrandsControl' : 'UtmBuilder-RelatedCategoryControl',
          hasValue ? 'Field_with_value' : '',
          isMulti && selectedList.length > 0 ? 'UtmBuilder-RelatedBrandsControl_has_clear' : '',
        ]
          .filter(Boolean)
          .join(' ')}
        onClick={() => setIsOpen(true)}
        onKeyDown={(event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault()
            setIsOpen(true)
          }
        }}
        role="button"
        tabIndex={0}
      >
        {isMulti ? (
          <div className="UtmBuilder-RelatedBrandsChips">
            {selectedList.map((item) => (
              <span key={item.catalogTaxonomyNodeId} className="UtmBuilder-RelatedBrandsChip">
                <span className="UtmBuilder-RelatedBrandsChipLabel">{item.pathLabel || item.catalogTaxonomyNodeName}</span>
                <button
                  type="button"
                  className="UtmBuilder-RelatedBrandsChipRemove"
                  title="Прибрати категорію"
                  onClick={(event) => {
                    event.stopPropagation()
                    handleRemove(item.catalogTaxonomyNodeId)
                  }}
                >
                  <Icon name="times" weight="regular" size={12} />
                </button>
              </span>
            ))}
          </div>
        ) : (
          <input type="text" className="UtmBuilder-RelatedCategoryInput" value={pathLabel} readOnly placeholder="" />
        )}
        {hasValue ? (
          <button
            type="button"
            className={isMulti ? 'UtmBuilder-RelatedBrandsClear' : 'UtmBuilder-RelatedCategoryClear'}
            title="Очистити"
            onClick={(event) => {
              event.stopPropagation()
              onChange(isMulti ? [] : null)
            }}
          >
            <Icon name="times" weight="regular" size={12} />
          </button>
        ) : null}
        <span className="Field-Icon Field-Icon_position_right UtmBuilder-RelatedCategoryAngle">
          <Icon name="angle-down" />
        </span>
        <span className="Field-Bar" />
        <label>{label}</label>
      </div>

      {isOpen ? (
        <PopUp show title={popupTitle} close={() => setIsOpen(false)} className={packagingStyles.popup}>
          <div className={packagingStyles.popupBody}>
            {visibleNodes.length === 0 ? (
              <p className={packagingStyles.empty}>Немає категорій</p>
            ) : (
              <CatalogTaxonomyNodePicker
                key={selectedIds.join(',') || 'none'}
                nodes={visibleNodes}
                nodesById={nodesById}
                assignedIds={selectedIds.length > 0 ? selectedIds : selectedNodeId ? [selectedNodeId] : []}
                mode="select"
                selectAnyNode
                hint="Батьківська категорія включає вкладені"
                focusNodeId={selectedNodeId}
                onPick={handlePick}
              />
            )}
          </div>
        </PopUp>
      ) : null}
    </div>
  )
}

export default GiftFundCategoryPicker
